import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Indicator from '../Indicator/Indicator';

const DeletConfirm = ({ handleSubmit, closeModal, loading }) => {
    const yesRef = useRef(null);
    const noRef = useRef(null);

    useEffect(() => {
        if (yesRef.current) {
            yesRef.current.focus();
        }

        // Tally-like warning beep sound
        const playAlertBeep = () => {
            try {
                const AudioContextClass = window.AudioContext || window.webkitAudioContext;
                if (!AudioContextClass) return;
                const ctx = new AudioContextClass();
                
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                
                osc.type = 'sine';
                osc.frequency.setValueAtTime(800, ctx.currentTime);
                
                gain.gain.setValueAtTime(0.12, ctx.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.15);
                
                osc.connect(gain);
                gain.connect(ctx.destination);
                
                osc.start();
                osc.stop(ctx.currentTime + 0.15);
            } catch (e) {
                console.warn("Web Audio API not supported:", e);
            }
        };

        playAlertBeep();
    }, []);

    const handleKeyDown = (e) => {
        const key = e.key.toLowerCase();
        
        // Stop event propagation to prevent it from bubbling up to window after unmount
        e.stopPropagation();
        if (e.nativeEvent) {
            e.nativeEvent.stopImmediatePropagation();
        }

        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            if (document.activeElement === yesRef.current) {
                noRef.current?.focus();
            } else {
                yesRef.current?.focus();
            }
        } else if (key === 'y') {
            e.preventDefault();
            handleSubmit(new Event('submit'));
        } else if (key === 'n' || e.key === 'Escape') {
            e.preventDefault();
            closeModal();
        }
    };

    return (
        <div className='form' onKeyDown={handleKeyDown}>
            {
                loading ?
                    <Indicator /> :
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            right: 'auto',
                            bottom: 'auto',
                            transform: 'translate(-50%, -50%)',
                            width: '15%',
                            height: '150px',
                            borderWidth: 1,
                            borderColor: 'black',
                            borderStyle: 'solid',
                            background: '#fff',
                            zIndex: 1000,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                        <div className='container'>
                            <div className='row ps-3'>
                                <div className='col-12 mb-5 pe-4'>
                                    Delete ?
                                </div>
                                <div className='col-3 offset-1'>
                                    <Link ref={yesRef} tabIndex={0} style={{ textDecoration: 'none', color: '#000', outline: 'none' }} className="modal_link" onClick={() => { return (handleSubmit(new Event('submit'))) }} ><span style={{ color: 'red' }}>Y</span>es</Link>
                                </div>
                                <div className='col-2'>or</div>
                                <div className='col-3'>
                                    <Link ref={noRef} tabIndex={0} style={{ textDecoration: 'none', color: '#000', outline: 'none' }} className='modal_link' onClick={() => { return (closeModal()) }}><span style={{ color: 'red' }}>N</span>o</Link>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </div>
    )
}

export default React.memo(DeletConfirm)
